import { Pipe, PipeTransform } from '@angular/core';

import { Device } from '../interfaces/item.interface';

import { ItemsService } from './../services/items.service';
import { LocationsService } from './../services/locations.service';
import { AgentMetaService } from './../services/agent-meta.service';
import { DeviceCategoryService } from './../services/device-category.service';

@Pipe({
  name: 'icon'
})
export class IconPipe implements PipeTransform {

  constructor(
    private items: ItemsService,
    private categories: DeviceCategoryService,
    private agents: AgentMetaService,
    private locations: LocationsService
  ) { }

  transform(value: any, args?: any): any {

    let icon = 'unknown';

    if (!!value) {
      let id = value.id || value.deviceId;
      // if this is a code item handle flow control icons as a special case
      if (!!value.codeItemId) {
        // special case: the program flow agent requires knowledge of the command to infer an icon correctly
        if (id === 100000 && !!value.command) {
          switch (value.command.command) {
            case 'DELAY': icon = 'control-delay'; break;
            case 'BREAK': icon = 'control-break'; break;
            case 'RETURN': icon = 'control-stop'; break;
          }
        } else {
          switch (value.type) {
            case 2: icon = 'control-conditional'; break;
            case 3: icon = 'control-loop'; break;
            case 4: icon = 'control-else'; break;
          }
        }
      }

      if (icon === 'unknown') {
        if (!!id) {
          let item = this.items.getItem(id);
          // console.log('icon: item for icon ', item);
          if (!!item) {
            // if this is an agent, resolve the icon using the agent meta service
            if (item.type === 9) {
              icon = this.agents.getIconForId(id);
            } else {
              icon = this.categories.getCategoryIconForItem(item);
            }
          } else {
            // might be a location
            let loc = this.locations.getLocationById(id);
            if (!!loc) {
              if (loc.type === 8) {
                icon = 'room';
              }
            }
          }
        }
      }

      if (!value.enabled || !!value.protected || !!value.hasProtected) {
        icon += ' protected grey';
      }
    }

    // console.log('icon: icon for item is ', value, icon);
    return icon;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/icon.pipe.ts